module.exports = __webpack_public_path__ + "media/images/lb/486-3edf24385a846eb17c2962e1c440ffef.svg";